// GIẢM NGUYÊN NHÂN GẶP CAPTCHA (17/10/2026) — CHỈ làm bot nhẹ nhàng hơn / dừng sớm hơn / báo người rõ hơn. KHÔNG giải, né hay vượt CAPTCHA
// (không giả vân tay, không xoay IP, không tự kéo thanh trượt): CAPTCHA luôn do NGƯỜI giải trên trình duyệt của bot.
//
// Bằng chứng (docs/nhat-ky-thu-thuc-te-2026-10-05.md T-1): CAPTCHA TikTok tái xuất 7 phút sau khi người bấm "Cho chạy lại" — việc dồn ngay sau khi mở lại
// làm TikTok nhìn thêm một nick đang bị nghi. Hai quy tắc dưới đây (theo mạng) chỉ làm Boss GIÃN việc ra, không đụng vào trang.
import { MA_CAN_NGUOI } from "./can-nguoi";

/** Sau "Cho chạy lại" một tạm dừng CAPTCHA/xác minh, Boss giữ bot nghỉ chừng này phút (mới giao lại việc của mạng đó). Mạng không có trong bảng: không giữ. */
export const NGUOI_SAU_MO_PHUT: Readonly<Record<string, number>> = { tiktok: 30 };
/** Hai lần chạy liên tiếp của CÙNG bot trên một mạng cách nhau tối thiểu chừng này phút (lần sau xếp hàng chờ). Mạng không có trong bảng: không giữ. */
export const NGHI_GIUA_LAN_CHAY_PHUT: Readonly<Record<string, number>> = { tiktok: 10 };
/** Mã của dòng "tạm dừng nguội" Boss tự dựng (không có trong bảng bot_tam_dung) — chỉ xuất hiện trong lý do chặn việc. */
export const MA_NGUOI_SAU_MO = "nguoi_sau_mo";
/** Mã tạm dừng có nguội sau khi mở lại (CAPTCHA / xác minh — không áp cho đăng xuất, cần người…). */
export const MA_CAN_NGUOI_SAU_MO: readonly string[] = ["captcha", "xac_minh"];
/** Hai bot cùng mạng bị CAPTCHA trong chừng này phút = cùng một đợt (gom thông báo). */
export const KHOANG_CUNG_DOT_PHUT = 30;

export const phutNguoiSauMo = (nenTang: string): number => NGUOI_SAU_MO_PHUT[nenTang] ?? 0;
export const phutNghiGiuaLan = (nenTang: string): number => NGHI_GIUA_LAN_CHAY_PHUT[nenTang] ?? 0;
export const laMaCoNguoiSauMo = (ma: string): boolean => ma !== MA_CAN_NGUOI && MA_CAN_NGUOI_SAU_MO.includes(ma);

/** Số liệu gần đây của một lần bị CAPTCHA (24 giờ trước đó). */
export interface NguyenNhanCaptcha {
  /** Số lần chạy (đã kết thúc thật) của chính bot này trên mạng đó trong 24 giờ qua. */
  luot24h: number;
  /** Số bot KHÁC của cùng tài khoản đã chạy mạng đó trong 24 giờ qua. */
  botKhacChay: number;
  /** Tên các bot KHÁC của cùng tài khoản cũng bị CAPTCHA/xác minh mạng đó trong 24 giờ qua. */
  botKhacBi24h: string[];
  /** Trong số đó, tên các bot bị trong KHOANG_CUNG_DOT_PHUT phút gần nhất (cùng đợt). */
  botCungDot: string[];
}

/** Lời khuyên NGẮN cho thông báo/thẻ bot: đừng bấm Chạy lại ngay; giải xong chờ N phút. nn = null: không có số liệu. */
export function loiKhuyenCaptcha(tenMang: string, phutCho: number, nn: NguyenNhanCaptcha | null): string {
  const doan: string[] = [];
  doan.push(phutCho > 0
    ? `ĐỪNG bấm chạy lại ngay: giải xong ở trình duyệt của bot rồi CHỜ ít nhất ${phutCho} phút mới bấm “Cho chạy lại” (Boss cũng giữ bot nghỉ ${phutCho} phút sau khi mở lại)`
    : `Đừng bấm chạy lại ngay: giải xong ở trình duyệt của bot rồi chờ một lúc mới bấm “Cho chạy lại”`);
  if (nn) {
    const nguyen: string[] = [];
    if (nn.luot24h > 0) nguyen.push(`bot này đã chạy ${nn.luot24h} lần ${tenMang} trong 24 giờ qua`);
    if (nn.botKhacChay > 0) nguyen.push(`${nn.botKhacChay} bot khác của bạn cũng chạy ${tenMang}`);
    if (nn.botKhacBi24h.length) nguyen.push(`${nn.botKhacBi24h.length} bot khác (${nn.botKhacBi24h.slice(0, 4).join(", ")}${nn.botKhacBi24h.length > 4 ? "…" : ""}) cũng bị CAPTCHA`);
    if (nguyen.length) doan.push(`Nguyên nhân khả dĩ: ${nguyen.join("; ")}${nn.botKhacBi24h.length ? " — nhiều bot cùng bị thường là cùng mạng/IP hoặc chạy dồn cùng lúc" : ""}`);
    doan.push(nn.botKhacBi24h.length || nn.botKhacChay > 1
      ? `Gợi ý: giãn lịch (mỗi lần chạy cách nhau vài chục phút), bớt số bot ${tenMang} chạy cùng một mạng, giảm số video/lượt`
      : `Gợi ý: giãn lịch và giảm số video/lượt của kịch bản ${tenMang}`);
  }
  return doan.join(". ") + ".";
}

/** Thông báo GỌN cho bot thứ hai trở đi trong cùng đợt (không đỏ, không lặp lại hướng dẫn). */
export function chuGomDotCaptcha(tenBot: string, tenMang: string, lyDo: string, cungDot: string[]): string {
  return `⚠ ${tenBot} cũng bị ${lyDo} trên ${tenMang} — cùng đợt với ${cungDot.slice(0, 4).join(", ")}${cungDot.length > 4 ? "…" : ""} (${cungDot.length + 1} bot trong ${KHOANG_CUNG_DOT_PHUT} phút). Làm theo hướng dẫn ở thông báo đầu: giải xong, chờ rồi mới “Cho chạy lại”.`;
}
